import { render, staticRenderFns } from "./DropdownDokumentasiList.vue?vue&type=template&id=624d4a5b&scoped=true"
import script from "./DropdownDokumentasiList.vue?vue&type=script&lang=js"
export * from "./DropdownDokumentasiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624d4a5b",
  null
  
)

export default component.exports